import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Gallery } from './pages/Gallery';
import { Contact } from './pages/Contact';
import { Booking } from './pages/Booking';
export function AppRouter() {
  return <HelmetProvider data-id="element-4">
      <BrowserRouter data-id="element-5">
        <App data-id="element-6">
          <Routes data-id="element-7">
            <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
            <Route path="/about" element={<About data-id="element-11" />} data-id="element-10" />
            <Route path="/gallery" element={<Gallery data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<Contact data-id="element-15" />} data-id="element-14" />
            <Route path="/booking" element={<Booking data-id="element-17" />} data-id="element-16" />
          </Routes>
        </App>
      </BrowserRouter>
    </HelmetProvider>;
}